import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import "../../assets/stylesheets/legal-service.css";
import { Helmet } from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import i18n from 'i18next';
import {ContactInfoContext} from "./ContactInfoContext";

function LegalService() {
    const { t } = useTranslation(["legal"]);
    const { contactInfo } = useContext(ContactInfoContext);

    return (
        <>
            <Helmet>
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/${t("legalservice")}`} />
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/${t("legalservice")}`} />
                <meta property="og:title" content={t("legTitle")} />
                <meta property="og:site_name" content="sievn.am" />
                <meta property="og:description" content={t("legDescribe")} />
                <meta property="og:image" content={Logo} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta name="description" content={t("legDescribe")} />
                <title>{t("legTitle")}</title>
            </Helmet>
            <div className="legal-page">
                <div className="about-start-legal">
                    <img src={contactInfo.legalUrl} alt="Legal Services" />
                </div>

                <div className="main-container-legal">
                    <div className="headings-legal">
                        <h1>
                            <em>{t("attornay")}</em>
                        </h1>
                    </div>

                    <h3 className="subtitle-legal">{t("legalTitle")}</h3>
                    <p className="content-legal">{t("legalcont1")}</p>
                    <p className="content-legal">{t("legalcont2")}</p>
                    <p className="content-legal">{t("legalcont3")}</p>
                </div>
            </div>
        </>
    );
}

export default LegalService;